<ng-container *transloco="let t; read: 'auth'">
<h3>{{ t('pageNotFoundTitle') }}</h3>
<p>{{ t('pageNotFoundMessage') }}</p>
<a [routerLink]="['/']">
  {{ t('backToHome') }}
</a>
</ng-container>
